module.exports = __webpack_public_path__ + "img/workspace-onboarding/install-desktop-app-f49ea1de42a137c56b2991bad5cdd100.png";